/*
  Saves us from making a network request to https://images.opendoor.com/source/s3/imgdrop-production/2023-06-1687822944103-28395.svg?preset=square-2048

*/
import { cn } from '@opendoor/atoms/utils';

export const GlobalNavSVG = ({ isOpen }: { isOpen: boolean }) => {
  const barClassName =
    'origin-center transition-transform duration-300 ease-[cubic-bezier(0.55,0,0.15,1)]';

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        className={cn(barClassName, isOpen ? 'translate-y-0 rotate-45' : '-translate-y-1')}
        d="M4 12H20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className={cn(barClassName, isOpen ? 'translate-y-0 -rotate-45' : 'translate-y-1')}
        d="M4 12H20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
